import type { ReactNode } from "react";

type AdminPageTitleProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
};

/** Consistent page heading + optional actions row for admin screens. */
export function AdminPageTitle({
  title,
  description,
  actions,
}: AdminPageTitleProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-border pb-6 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 space-y-1">
        <h2 className="text-xl font-bold tracking-tight text-foreground sm:text-3xl">
          {title}
        </h2>
        {description ? (
          <p className="max-w-2xl text-sm text-muted-foreground">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
